import React from 'react';
import './Button.css'

const FormSubmitButton = ({buttonText, buttonType, linkTo, disable}) => {
  const inputButton = <input type='submit' value={buttonText} disabled={disable}/>;
  const internalLinkButton = <a href={linkTo} className='btn btn-full' disabled={disable}>{buttonText}</a>;
  return (
    buttonType === 'input' ? inputButton : internalLinkButton
  )
}

export default FormSubmitButton;



// WEBPACK FOOTER //
// ./src/components/Button.js